<div class="avatar-group avatar-group-{{size}}">
  @for (user of users | slice:0:itemsToShow; track user; let i = $index) {
    <sc-avatar [user]="user" [size]="size" [class.ms-0]="i == 0"></sc-avatar>
  }
  @if (users.length - itemsToShow > 0) {
    <span class="avatar avatar-{{size}}">
      <span class="avatar-title rounded-circle border border-white">+{{users.length - itemsToShow}}</span>
    </span>
  }
</div>
